/* eslint-disable import/prefer-default-export */
import api from "./axios";

export async function getBillings(regional) {
  const response = await api.get(`/billings/home/${regional}`);
  return response;
}

export async function getBilling(deviceId) {
  const response = await api.get(`/billings/${deviceId}`);
  return response;
}

export async function postBilling(billing) {
  const response = await api.post("/billings", billing);
  return response;
}

export async function deleteBilling(financeId) {
  const response = await api.delete(`/billings/${financeId}`);
  return response;
}

export async function putBilling(billing, financeId) {
  const response = await api.put(`/billings/${financeId}`, billing);
  return response;
}
